<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
    :before-close="handleClose"
  >
    <el-form
      :model="form"
      ref="vssForm"
      class="form_type1_box"
      hide-required-asterisk
    >
      <el-row v-if="manualInput" :gutter="86">
        <el-col :span="24">
          <el-form-item :label="$t('message.macauAddress.address')">
            <el-input
              v-model="form.manual"
              maxlength="300"
              @input="inputToUpperCase($event, 'manual')"
              :placeholder="$t('message.macauAddress.manual_address_plh')"
            ></el-input>
            <div class="manual_input">
              <span @click="backToSearch">{{
                $t("message.back_to_address_search")
              }}</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else :gutter="86">
        <el-col :span="24">
          <el-form-item :label="$t('message.macauAddress.area')">
            <el-radio-group v-model="form.area">
              <el-radio :label="$t('message.macauAddress.area_macau')">{{
                $t("message.macauAddress.area_macau")
              }}</el-radio>
              <el-radio :label="$t('message.macauAddress.area_taipa')">{{
                $t("message.macauAddress.area_taipa")
              }}</el-radio>
              <el-radio :label="$t('message.macauAddress.area_coloane')">{{
                $t("message.macauAddress.area_coloane")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('message.macauAddress.street_name')">
            <el-select
              class="addressSearch"
              ref="addressSearch"
              v-model="form.address"
              :multiple="$store.state.isMobile"
              filterable
              remote
              reserve-keyword
              :popper-append-to-body="false"
              :placeholder="$t('message.macauAddress.address_plh')"
              :remote-method="remoteMethod"
              :loading="loading"
              @focus="addressFocus"
              @blur="handleBlur"
              @change="selectChange"
              value-key="id"
            >
              <el-option
                v-for="item in address"
                :key="item.id"
                :label="item.result"
                :value="item"
              ></el-option>
            </el-select>
            <div class="manual_input">
              {{ $t("message.no_desired_result") }}
              <span @click="manualInputClick">{{
                $t("message.manual_input")
              }}</span>
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item :label="$t('message.macauAddress.doorPlate')">
            <el-input
              v-model="form.doorPlate"
              maxlength="50"
              @input="inputToUpperCase($event, 'doorPlate')"
              :placeholder="$t('message.macauAddress.doorPlate_plh')"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item :label="$t('message.macauAddress.tips')">
            <div class="input_inline">
              <div class="input_inline_div">
                <span>{{ $t("message.macauAddress.no") }}</span>
                <el-input
                  v-model="form.phase"
                  maxlength="8"
                  @input="inputToUpperCase($event, 'phase')"
                ></el-input>
                <span>{{ $t("message.macauAddress.phase") }}</span>
              </div>
              <div v-if="lan != 'PT'" class="horizontal">-</div>
              <div class="input_inline_div">
                <span v-if="lan != 'PT'">{{
                  $t("message.macauAddress.no")
                }}</span>
                <el-input
                  v-model="form.block"
                  maxlength="8"
                  @input="inputToUpperCase($event, 'block')"
                ></el-input>
                <span>{{ $t("message.macauAddress.block") }}</span>
              </div>
              <div class="horizontal">-</div>
              <div class="input_inline_div">
                <span v-if="lan != 'PT'">{{
                  $t("message.macauAddress.no")
                }}</span>
                <el-input
                  v-model="form.floor"
                  maxlength="8"
                  @input="inputToUpperCase($event, 'floor')"
                ></el-input>
                <span>{{ $t("message.macauAddress.floor") }}</span>
              </div>
              <div v-if="lan != 'PT'" class="horizontal">-</div>
              <div class="input_inline_div">
                <span v-if="lan != 'PT'">{{
                  $t("message.macauAddress.no")
                }}</span>
                <el-input
                  v-model="form.room"
                  maxlength="8"
                  @input="inputToUpperCase($event, 'room')"
                  @keyup.enter.native="save"
                ></el-input>
                <span>{{ $t("message.macauAddress.room") }}</span>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="!manualInput" class="full_address">{{ addressFull }}</div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save">{{
        $t("message.save")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import MacauAddressAPI from "../../../../api/MacauAddressAPI";
export default {
  props: {
    visible: Boolean,
    title: {
      type: String,
      default: function () {
        return this.$t("message.macauAddress.dialog_title");
      },
    },
  },
  data() {
    return {
      loading: false,
      form: {
        doorPlate: "",
        block: "",
        floor: "",
        room: "",
        phase: "",
      },
      address: [],
      value: [],
      list: [],
      addressFull: "",
      manualInput: false,
    };
  },
  mounted() {
    this.list = this.address.map((item) => {
      return { value: `${item.id}`, label: `${item.result}` };
    });
  },
  computed: {
    lan() {
      return this.$i18n.locale;
    },
  },
  watch: {
    form: {
      // newName, oldName
      handler() {
        const form = this.form;
        let area = form.area ? `${form.area}` : "";
        let address = this.$store.state.isMobile
          ? (form.address && form.address[0]) || null
          : form.address;
        let addressStreet = address
          ? address.street[address.language == "PT" ? "namePt" : "nameCn"]
          : "";
        let building = address
          ? address.building[address.language == "PT" ? "namePt" : "nameCn"]
          : "";
        let phase = "";
        let doorPlate = "";
        let block = "";
        if (this.lan == "PT") {
          phase = form.phase
            ? `${this.$t("message.macauAddress.no")} ${this.$t(
                "message.macauAddress.num"
              )} ${form.phase}`
            : "";
          doorPlate = form.doorPlate
            ? `${this.$t("message.macauAddress.doorPlate2")} ${
                form.doorPlate
              }, `
            : "";
          block = form.block
            ? `${this.$t("message.macauAddress.phase")} ${this.$t(
                "message.macauAddress.num"
              )} ${form.block}`
            : "";
        } else {
          phase = form.phase
            ? `${form.phase} ${this.$t("message.macauAddress.phase")}`
            : "";
          doorPlate = form.doorPlate
            ? `${form.doorPlate} ${this.$t(
                "message.macauAddress.doorPlate2"
              )}, `
            : "";
          block = form.block
            ? `${this.$t("message.macauAddress.no")} ${form.block} ${this.$t(
                "message.macauAddress.block2"
              )}`
            : "";
        }
        let floor = form.floor
          ? `${form.floor} ${this.$t("message.macauAddress.floor")}`
          : "";
        let room = form.room
          ? `${form.room} ${this.$t("message.macauAddress.room2")}`
          : "";
        if (address && address.language == "PT") {
          this.addressFull = `${
            this.lan == "PT" ? "" : area + ", "
          } ${addressStreet} ${doorPlate} ${
            building ? building : ""
          } ${phase} ${block} ${floor} ${room} ${
            this.lan == "PT" ? "," + area : ""
          }`;
        } else {
          this.addressFull = [
            area,
            addressStreet,
            doorPlate,
            building,
            phase,
            block,
            floor,
            room,
          ]
            .filter((e) => e)
            .join(" ");
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // done
    handleClose() {
      this.form = {
        area: this.$t("message.macauAddress.area_macau"),
        doorPlate: "",
        block: "",
        floor: "",
        room: "",
      };
      this.manualInput = false;
      this.$emit("close");
    },
    remoteMethod(query) {
      // console.log(query);
      if (query !== "") {
        this.loading = true;
        MacauAddressAPI.address(encodeURI(query))
          .then((res) => {
            this.loading = false;
            this.address = res;
          })
          .catch((err) => {
            this.$error(err);
          });
        // setTimeout(() => {
        //   this.loading = false;
        //   this.address = this.list.filter(item => {
        //     return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        //   });
        // }, 200);
      } else {
        this.address = [];
      }
    },
    save() {
      const form = this.form;
      let macauAddress = {};
      const setValue = (name, value) => {
        if (value) {
          macauAddress[name] = value;
        }
      };
      if (this.manualInput) {
        macauAddress.textCn = this.form.manual;
      } else {
        if (this.$store.state.isMobile) {
          form.address = form.address[0];
        }
        if (form.address) {
          if (form.address.street) {
            setValue("streetCode", form.address.street.code);
            setValue("streetNameCn", form.address.street.nameCn);
            setValue("streetNamePt", form.address.street.namePt);
          }
          setValue("buildingCode", form.address.building.code);
          setValue("parishCode", form.address.building.parish.code);
          setValue("buildingNameCn", form.address.building.nameCn);
          setValue("buildingNamePt", form.address.building.namePt);
          setValue(
            form.address.language == "CN" ? "doorPlateCn" : "doorPlatePt",
            form.doorPlate
          );
          setValue(
            form.address.language == "CN" ? "floorCn" : "floorPt",
            form.floor
          );
        }
        setValue("block", form.block);
        setValue("room", form.room);
        setValue("textCn", this.addressFull);
      }
      this.form = {
        area: this.$t("message.macauAddress.area_macau"),
        doorPlate: "",
        block: "",
        floor: "",
        room: "",
      };
      this.manualInput = false;
      this.$emit("save", macauAddress);
    },
    // 手動輸入
    manualInputClick() {
      this.manualInput = true;
      this.$set(this.form, "address", null);
    },
    // 返回地址搜尋
    backToSearch() {
      this.manualInput = false;
      delete this.form.manual;
    },
    // 解決移動端無法打開輸入法問題
    // event
    addressFocus() {
      // this.handleBlur();
      // console.log(this.$refs["addressSearch"].$el.querySelector("input"));
      this.$refs["addressSearch"].$el.querySelector("input").focus();
    },
    handleBlur() {
      Array.from(document.getElementsByClassName("el-select")).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute("readOnly");
          item.children[0].children[0].onblur = function () {
            let _this = this;
            setTimeout(() => {
              _this.removeAttribute("readOnly");
            }, 200);
          };
        }
      );
    },
    selectChange(val) {
      // console.log(val);
      if (this.$store.state.isMobile) {
        this.form.address = [val[val.length - 1]];
      }
    },
    // 輸入字母轉大寫
    inputToUpperCase(val, name) {
      console.log("inputToUpperCase");
      this.form[name] = val.toUpperCase();
    },
  },
  created() {
    // this.form.area = this.$t("message.macauAddress.area_macau");
    this.$set(this.form, "area", this.$t("message.macauAddress.area_macau"));
    // this.$nextTick(() => {
    //   console.log("a: ", document.getElementsByClassName("el-select"));
    //   this.handleBlur();
    //   if (this.$store.state.isMobile) {
    //     console.log(this.$refs["addressSearch"].$el);
    //     this.$refs.addressSearch.$el.querySelector("input").focus();
    //   }
    // });
  },
};
</script>

<style lang="scss" scoped>
.full_address {
  color: #38959d;
  font-size: 20px;
}
.manual_input {
  text-align: center;
  font-size: 14px;
  color: #626167;
}
.manual_input span {
  text-decoration: underline;
  cursor: pointer;
}
.input_inline {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  word-break: keep-all;
  flex-wrap: nowrap;
  white-space: nowrap;
}
.input_inline div {
  display: flex;
  flex-direction: row;
  align-items: center;
  word-break: keep-all;
  flex-wrap: nowrap;
  white-space: nowrap;
  /deep/input {
    height: 34px !important;
    font-size: 14px !important;
    line-height: 38px;
    padding: 0 10px;
    margin-left: 6px;
    margin-right: 6px;
  }
}
.horizontal {
  padding: 0 10px;
}
/deep/.el-radio-group {
  width: 100%;
  display: flex;
  flex-direction: row !important;
  align-items: flex-start;
  .el-radio {
    margin-right: 30px !important;
  }
  .el-radio__label {
    font-size: 16px;
  }
  .el-radio__inner {
    width: 16px;
    height: 16px;
  }
}
@media screen and (max-width: 767px) {
  .input_inline {
    flex-wrap: wrap;
  }
  .horizontal {
    display: none !important;
  }
}
</style>
